import React from "react";
import { createPortal } from "react-dom";
import DOMPurify from "dompurify";
import { ExpertDto } from "../types/resources";
import "../styles/resources.css";

interface ExpertModalProps {
    isOpen?: boolean;  // For backward compatibility
    expert: ExpertDto | null;
    onClose: () => void;
}

export default function ExpertModal({ isOpen = true, expert, onClose }: ExpertModalProps) {
    if (!isOpen || !expert) return null;

    const sanitizedContent = DOMPurify.sanitize(expert.modalContent);

    return createPortal(
        <div className="resource-modal-overlay" onClick={onClose}>
            <div className="resource-modal expert-modal" onClick={(e) => e.stopPropagation()}>
                <button className="resource-modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <div className="resource-modal-content">
                    <div className="expert-modal-header">
                        <img
                            src={expert.expertImageUrl}
                            alt={expert.title}
                            className="expert-modal-img"
                        />
                        <div className="expert-modal-info">
                            <h2 className="resource-modal-heading">{expert.modalHeading}</h2>
                            <h3 className="expert-modal-name">{expert.title}</h3>
                        </div>
                    </div>

                    <div
                        className="resource-modal-body"
                        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                    />

                    <div className="resource-modal-actions">
                        <button className="resource-modal-close-btn" onClick={onClose}>
                            {expert.modalCloseLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

